import { GlobalLoadingContext, NavListContext, NavShowContext, useThrottledHandler } from 'App';
import { CiSearch } from 'react-icons/ci';
import {
  Button,
  InfiniteScroll,
  Input,
  Picker,
  PullToRefresh,
  SearchBar,
  SpinLoading,
  Switch,
  Toast,
} from 'antd-mobile';
import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import termsApi, { TermsNodeListDT } from 'services/apis/cnt2/term-api';
import { useWindowSize } from 'usehooks-ts';
import styles from './index.module.scss';
import ImageList from 'components/dot/image-list';
import { defaultPageParams } from 'services/request';
import sleep from 'utils/threadUtil';
import PostsApi, { PagePostDT } from 'services/apis/cnt2/post-api';
import { PageParams } from 'services/CommonDT';
import { useImmer } from 'use-immer';
import { PageQueryParams } from 'services/apis/cnt2/CommonDT';
import CountDownText from 'components/dot/countown-text';
import { isEmpty } from 'utils/listUtil';
import {
  AiOutlineArrowDown,
  AiOutlineArrowUp,
  AiOutlineBackward,
  AiOutlineHome,
  AiOutlineRollback,
  AiOutlineSearch,
} from 'react-icons/ai';
import TitleNav from 'components/frame/title-nav';

const Search = () => {
  const showGlobalLoading = useContext(GlobalLoadingContext).showGlobalLoading;

  const navigate = useNavigate();
  const state = useLocation().state;
  const updateNavShowState = useContext(NavShowContext).updateNavShowState;
  const defaultSearchCategory = state.searchCategory;
  const defaultSearchCategoryId = state.searchCategoryId;
  const [searchCategory, updateSearchCategory] = useState(defaultSearchCategory);
  const [searchCategoryId, updateSearchCategoryId] = useState(defaultSearchCategoryId);
  const [searchAllCategory, toggleSearchAllCategory] = useState(state.defaultSearchAllCategory);
  const [searchKeyword, updateSearchKeyword] = useState<string>(
    // "【" +
    //   (searchAllCategory ? "所有资源" : searchCategory) +
    //   "】" +
    state.searchKeyword
  );
  const [afterEnterSearch, toggleAfterEnterSearch] = useState(false);

  const [hasMore, setHasMore] = useState(true);
  const [postList, setPostList] = useState<PagePostDT[]>([]);
  const [pageParams, updatePageParams] = useImmer<PageParams>(defaultPageParams);

  const getRealSearchKeyword = (searchKeyword): string => {
    let category = '【' + (searchAllCategory ? '所有资源' : searchCategory) + '】';
    return searchKeyword.replace(category, '');
  };
  const getPrefixedSearchKeyword = (searchKeyword): string => {
    let category = '【' + (searchAllCategory ? '所有资源' : searchCategory) + '】';
    return category + getRealSearchKeyword(searchKeyword);
  };
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState<(string | null)[]>(['M']);
  const basicColumns = [
    [
      { label: '周一', value: 'Mon' },
      { label: '周二', value: 'Tues' },
      { label: '周三', value: 'Wed' },
      { label: '周四', value: 'Thur' },
      { label: '周五', value: 'Fri' },
    ],
    [
      { label: '上午', value: 'am' },
      { label: '下午', value: 'pm' },
    ],
  ];

  useEffect(() => {
    // 修改导航
    updateNavShowState((draft) => {
      draft.showBottomNav = true;
      draft.showTop1Nav = true;
      draft.showTop2Nav = false;
      draft.showTitleNav = false;
    });
  }, []);
  useEffect(() => {
    // console.log('state', state);
    if (searchKeyword) {
      fetchPagePost(
        {
          termId: searchCategoryId,
          termTaxonomy: 'category',
        },
        {
          pageParams: defaultPageParams,
          searchParams: {
            keyword: searchKeyword,
            keywordType: 1,
          },
        },
        true
      );
    }
  }, [state]);

  const fetchPagePost = async (
    params: {
      termId?: string;
      termTaxonomy?: string;
    },
    data: PageQueryParams,
    initial = false
  ) => {
    showGlobalLoading();
    // Toast.show({
    //   icon: 'loading',
    //   content: <CountDownText seconds={5} />,
    //   duration: 3000,
    //   maskClickable: false,
    // });
    data.searchParams.keyword = getRealSearchKeyword(data.searchParams.keyword);
    const response = await PostsApi.page(params, data);
    if (response.code === 0 && response.successful) {
      const data = response.result.records;
      if (initial) {
        setPostList(response.result.records);
      }
      return data;
    }
  };
  const loadMore = async () => {
    console.log('loadMore');

    const _pageParams = {
      current: pageParams.current + 1,
      pageSize: pageParams.pageSize,
    };
    updatePageParams(_pageParams);

    const append = await fetchPagePost(
      {
        termId: searchCategoryId,
        termTaxonomy: 'category',
      },
      {
        pageParams: _pageParams,
        searchParams: {
          keyword: searchKeyword,
          keywordType: 1,
        },
      }
    );
    if (!append) {
      throw new Error('mock request failed');
    } else {
      setPostList((val) => {
        return [...val, ...append];
      });
      setHasMore(append.length >= pageParams.pageSize);
    }
    await sleep(3000);
  };
  const doSearch = (searchKeyword) => {
    if (searchKeyword) {
      fetchPagePost(
        {
          termId: searchCategoryId,
          termTaxonomy: 'category',
        },
        {
          pageParams: defaultPageParams,
          searchParams: {
            keyword: searchKeyword,
            keywordType: 1,
          },
        },
        true
      );
      toggleAfterEnterSearch(true);
    }
  };

  return (
    <div>
      {/* 顶部返回条 */}
      <>
        <div className=" sticky top-0 z-20">
          <TitleNav />
        </div>
      </>
      <center>
        {/* 搜索提示 */}
        <div className=" sticky top-14 bg-gradient-to-br from-purple-100 to-orange-200 border border-slate-200 z-10 flex flex-col items-center justify-start gap-1 my-3 px-3 py-1 pb-3 w-[80%] rounded-xl shadow-md">
          {/* 提示区域 */}
          <div className="w-full px-1 flex justify-between items-center text-sm">
            <div className=" grow flex flex-col text-start gap-1 tracking-widest">
              <div>搜索分区: {searchAllCategory ? '所有资源' : searchCategory}</div>
              <div className=" text-nowrap whitespace-nowrap">
                搜索资源: {searchKeyword.length <= 10 ? searchKeyword : searchKeyword.substring(0, 10) + '...'}
              </div>
            </div>
            <div className=" m-1 p-0.5 px-2 bg-pink-300 text-white rounded-md shadow-md">
              <AiOutlineRollback
                size={18}
                onClick={useThrottledHandler(() => {
                  window.history.go(-1);
                })}
              />
              <div>返回</div>
            </div>
          </div>
          {/* 搜索区域 */}
          <div className="  flex gap-1">
            {/* 当前分区 or 所有分区 */}
            {/* 有问题, 先不显示 */}
            <div className={[true && ' hidden'].join(' ')}>
              <Switch
                checked={searchAllCategory}
                defaultChecked={state.defaultSearchAllCategory}
                className={styles.mystyle}
                uncheckedText="当前分区"
                checkedText="所有资源"
                style={{
                  '--checked-color': '#FB923C',
                }}
                onChange={(searchAllCategory) => {
                  toggleSearchAllCategory(searchAllCategory);
                }}
              />
            </div>
            <div className=" grow flex gap-2">
              <div className=" w-full">
                {/* <Button
                onClick={() => {
                  setVisible(true);
                }}
              >
                选择
              </Button>
              <Picker
                columns={basicColumns}
                visible={visible}
                onClose={() => {
                  setVisible(false);
                }}
                value={value}
                onConfirm={(v: any) => {
                  setValue(v);
                }}
              /> */}
                <SearchBar
                  value={searchKeyword}
                  placeholder={'在【' + (searchAllCategory ? '所有资源' : searchCategory) + '】搜索资源'}
                  // showCancelButton={true}
                  maxLength={15}
                  icon={
                    <AiOutlineSearch
                      size={20}
                      color="orange"
                    />
                  }
                  onChange={(searchKeyword) => {
                    let prefix = '【' + (searchAllCategory ? '所有资源' : searchCategory) + '】';
                    if (getRealSearchKeyword(searchKeyword).indexOf(prefix) != -1) {
                      return;
                    }
                    updateSearchKeyword(
                      // getPrefixedSearchKeyword(searchKeyword)
                      searchKeyword
                    );
                  }}
                  onSearch={(searchKeyword) => {
                    doSearch(searchKeyword);
                  }}
                  className={[' tracking-widest text-sm', styles.mystyle].join(' ')}
                  style={{
                    '--border-radius': '8px',
                    '--background': '#ccc',
                    '--padding-left': '8px',
                    '--placeholder-color': '#666',
                  }}
                />
              </div>
              <Button
                size="small"
                color="warning"
                className=" text-nowrap"
                onClick={useThrottledHandler(() => {
                  doSearch(searchKeyword);
                })}
              >
                搜索
              </Button>
            </div>
          </div>
        </div>

        {/* 内容区域 */}
        <div>
          {/* 下拉刷新 */}
          <PullToRefresh
            disabled={false}
            threshold={50}
            pullingText={
              <div className=" flex justify-center items-center">
                <AiOutlineArrowDown
                  color="#666"
                  size={24}
                  className=" mr-2 inline-block"
                />
                <div className=" text-xs inline-block">
                  <div>下拉可以刷新</div>
                  <div>当前时间 {new Date().toLocaleTimeString()}</div>
                </div>
              </div>
            }
            canReleaseText={
              <div className=" flex justify-center items-center">
                <AiOutlineArrowUp
                  color="#666"
                  size={24}
                  className=" mr-2 inline-block"
                />
                <div className=" text-xs inline-block">
                  <div>释放立即刷新</div>
                  <div>当前时间 {new Date().toLocaleTimeString()}</div>
                </div>
              </div>
            }
            refreshingText={
              <div className=" flex justify-center items-center">
                <SpinLoading
                  style={{ '--size': '24px', '--color': '#666' }}
                  className=" mr-2 inline-block"
                />
                <div className=" text-xs inline-block">
                  <div>正在刷新...</div>
                  <div>当前时间 {new Date().toLocaleTimeString()}</div>
                </div>
              </div>
            }
            onRefresh={async () => {
              console.log('onRefresh');
              updatePageParams(defaultPageParams);
              fetchPagePost(
                {
                  termId: searchCategoryId,
                  termTaxonomy: 'category',
                },
                {
                  pageParams: defaultPageParams,
                  searchParams: {
                    keyword: searchKeyword,
                    keywordType: 1,
                  },
                },
                true
              );
              await sleep(3000);
            }}
          >
            <ImageList
              termName={searchCategory}
              termId={searchCategoryId}
              postList={postList}
              showMore={false}
              showChange={false}
            />
          </PullToRefresh>
          {/* 下拉加载更多 */}
          {
            <InfiniteScroll
              threshold={600}
              hasMore={hasMore && searchKeyword && afterEnterSearch}
              loadMore={loadMore}
            />
          }
        </div>
      </center>
    </div>
  );
};

export default Search;

export type NavDT = {
  btmTermList: TermsNodeListDT[];
  top1TermList: TermsNodeListDT[];
  top2TermList: TermsNodeListDT[];
  btmTermNow: TermsNodeListDT;
  top1TermNow: TermsNodeListDT;
  top2TermNow: TermsNodeListDT;
};
